import React from 'react';

function Audio({index, message, contextPath}) {
	const src = message.src ? (message.src.indexOf("http") > -1 || message.src.indexOf("https") > -1 ? message.src
		: `${contextPath}/api/files/${message.src}`) : '';

	return (
		<audio className='media' alt={message.alt} title={message.title} controls name="media" src={src} controlsList="nodownload noplaybackrate nofullscreen"/>
	);
}

export default Audio;